import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {TagService} from "../../serverService/tagService/TagService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import {
    RaikoGridOneColumn,
    RaikoSimpleInputOutlined,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";

export default function TagDetail({tagId = -1, handleAddNewItem, handleUpdateItem, handleCloseDialog}) {


    const service = new TagService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())
    const {fundID} = useAuthState()


    const [buttonTitle, setButtonTitle] = useState("افزودن");
    const [tagTitle, setTagTitle] = useState("")


    useEffect(() => {
        if (tagId >= 0) {
            getTagDetailFromServer()
            setButtonTitle("بروزرسانی")

        }
    }, [tagId]);

    function getTagDetailFromServer() {

        loading.show()
        service.getTagDetail(fundID, tagId)
            .then(response => {
                setTagTitle(response.name)
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleOperation() {
        if (tagTitle.trim().length > 0) {
            if (tagId >= 0) {
                handleUpdateTag()
            } else {
                handleCreateTag()
            }
        } else
            snackbar.showWarningMessage("لطفا نام تگ را به درستی وارد نمایید.")
    }

    function handleUpdateTag() {
        loading.show()
        service.updateTag(fundID, tagId, tagTitle)
            .then(response => {
                snackbar.showSuccessMessage("تگ با موفقیت بروزرسانی شد.")
                handleUpdateItem(tagId, response.name)
                handleCloseDialog()
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleCreateTag() {
        loading.show()
        service.addNewTag(fundID, tagTitle)
            .then(response => {
                snackbar.showSuccessMessage("تگ جدید با موفقیت افزوده شد.")
                setTagTitle("")
                handleAddNewItem(response.name)
            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoSimpleInputOutlined labelText={"نام"} setValue={setTagTitle} value={tagTitle}/>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={buttonTitle} onClick={handleOperation}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
